import { LOGOUT } from "../actions/app.js";
import { LOAD_LOCAL_INSPECTIONS, COPY_LOCAL_INSPECTION } from "../actions/local-inspections.js";

const initialState = { items: [] };

export default function localInspectionsReducer(state = initialState, action) {
	switch (action.type) {
		case LOGOUT:
			return { ...state, items: [] };

		case LOAD_LOCAL_INSPECTIONS:
			return { ...state, items: action.inspections };
			
		case COPY_LOCAL_INSPECTION: {
			const copy = JSON.parse(JSON.stringify(state.items));
			copy.push(action.copiedInsp);
			return { ...state, items: copy };
		}

		default:
			return state;
	}
}
